/* Model */
class EventLogHttpActionModel extends App.Models.BaseModel {
  modelUrl = 'EventLogHttpAction';
}

App.Models.EventLogHttpAction = EventLogHttpActionModel;

/* Collection */
class EventLogHttpActionCollection extends App.Collections.BaseCollection {
  url = 'EventLogHttpAction';
  model = App.Models.EventLogHttpAction;
}

App.Collections.EventLogHttpActions = EventLogHttpActionCollection;

/* Router */
class EventLogHttpActionRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'EventLogHttpAction';
    const model = App.Models.EventLogHttpAction;
    const collectionClass = App.Collections.EventLogHttpActions;

    super(entityName, model, collectionClass);
  }

  getTabIdSelector = () => {
    return 'EventLogHttpActionGrid';
  }

  removeGridHeader = function () {
    const tabId = this.getTabIdSelector();
    const element = document.querySelector(`#${tabId} div.gridHeaderContainer`);

    element && element.remove();
  }

  removeSaveGridLayoutButton = function () {
    const tabId = this.getTabIdSelector();
    const saveGridButton = document.querySelector(`#${tabId} .saveLayout.gridActionDiv`);
    const configButton = document.querySelector(`#${tabId} div.MonetUIGridActions > div.MonetUIGridActionsButton.EventLogHttpAction`)

    saveGridButton && saveGridButton.remove();
    configButton && configButton.remove();
  };


  makeListScreen = (layout) => {
    this.collectionFilter = Monet.Grid.Utils.getFilterToSearch(this.entityName);
    this.collectionCriteria = null;

    if (layout) {
      const tabIdSelector = this.getTabIdSelector();

      if (!this.permissionDenied) {
        Monet.Form.checkFormTemplate(tabIdSelector);
        this.generateDatamapper(this.entityName, layout);

        const form = this.renderMonetForm(this.entityName, layout, tabIdSelector);

        form.initializeGrid(this.customGridActions);

        this.removeGridHeader();
        this.removeSaveGridLayoutButton();

        this.local_collection = this.collection;
        this.collectionCriteria = this.getProjectionBasedOnIndex();

        this?.beforeList();

        this.executeCustomFilter(this.entityName);
      }
    } else {
        //Sem informação de layout, verifique se o servidor está funcionando corretamente
        new Greenmile.Components.AlertModal("Greenmile.error.layout.notFound")
            .show();
    }

    return this;
  };
}

App.Routers.EventLogHttpAction = EventLogHttpActionRouter;
